import { render, staticRenderFns } from "./FormSeparatorConfig.vue?vue&type=template&id=1d283d68&scoped=true"
import script from "./FormSeparatorConfig.vue?vue&type=script&lang=js"
export * from "./FormSeparatorConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d283d68",
  null
  
)

export default component.exports